import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const westchaseConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Westchase Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Westchase, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_westchase',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Westchase',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Westchase Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the upscale planned 
     communities and golf course neighborhoods of <strong>Westchase</strong> 
     with professional tree care that matches the standards of this premier 
     Tampa suburb. Well maintained properties here depend on expert tree 
     management and when trees overgrow, sustain storm damage, or develop 
     hazardous conditions near homes and common areas, our team handles 
     it with precision and care.`,

    `We specialize in <strong>precision tree removal and canopy management 
     in master planned communities</strong> large limb work near premium 
     homes and pools, storm response, palm and hardwood removals on HOA 
     and residential properties, and canopy thinning that reduces storm 
     risk without compromising your landscape's appeal. We respect your 
     property on every job.`,

    `<strong>Sam's Tree Service</strong> delivers expert, reliable tree care 
     throughout <strong>Westchase</strong> and surrounding 
     <strong>West Hillsborough</strong> communities protecting the value 
     and beauty of your property all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Westchase, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Westchase = () => <LocationPage config={westchaseConfig} />;
export default Services_Westchase;
